import { useTranslation } from "react-i18next";
import React from 'react';
export default function BillingToggle({
  isYearly,
  onToggle
}) {
  const {
    t
  } = useTranslation();
  return <div className="toggle-wrapper">
      <span className={`toggle-label ${!isYearly ? 'active' : ''}`}>{t("Monthly")}</span>
      <label className="toggle-switch">
        <input type="checkbox" checked={isYearly} onChange={e => onToggle(e.target.checked)} />
        <span className="slider"></span>
      </label>
      <span className={`toggle-label ${isYearly ? 'active' : ''}`}>{t("Yearly")}</span>
      {isYearly && <span className="savings-badge">{t("SAVE 20%")}</span>}
    </div>;
}